/**
 * Personas prontas do simulador do match. As respostas são ligadas ao `code` da
 * questão (não ao número), então continuam valendo se o admin reordenar ou
 * reescrever as perguntas — o que não pode mudar é a LETRA das alternativas.
 * São as mesmas personas do spec `match-scoring.spec.ts` do backend.
 */
export interface MatchSimulatorPersona {
	key: string;
	label: string;
	description: string;
	/** { CODE: 'letras' } — múltipla escolha concatena as letras ("AC"). */
	answersByCode: Record<string, string>;
}

export const MATCH_SIMULATOR_PERSONAS: MatchSimulatorPersona[] = [
	{
		key: 'tiago',
		label: 'Ansiedade + trabalho',
		description:
			'Ansiedade e burnout, quer algo prático com metas, primeira terapia, mulher, de manhã.',
		answersByCode: {
			TOPICS: 'AC',
			STYLE: 'A',
			PRIORITY: 'C',
			EXPERIENCE: 'A',
			GENDER_PREF: 'A',
			AUDIENCE: 'C',
			AVAILABILITY: 'A',
			AGE: 'C',
		},
	},
	{
		key: 'sofia',
		label: 'Luto e relações',
		description:
			'Relacionamentos e luto, estilo reflexivo, quer ser ouvida, sem preferência de gênero, à noite.',
		answersByCode: {
			TOPICS: 'DF',
			STYLE: 'B',
			PRIORITY: 'E',
			EXPERIENCE: 'B',
			GENDER_PREF: 'D',
			AUDIENCE: 'C',
			AVAILABILITY: 'C',
			AGE: 'D',
		},
	},
	{
		key: 'juliana',
		label: 'Jovem e família',
		description:
			'Autoestima e família, estilo presente, busca acolhimento, à tarde, mais jovem.',
		answersByCode: {
			TOPICS: 'EH',
			STYLE: 'C',
			PRIORITY: 'B',
			EXPERIENCE: 'A',
			GENDER_PREF: 'D',
			AUDIENCE: 'B',
			AVAILABILITY: 'B',
			AGE: 'B',
		},
	},
	{
		key: 'pedro',
		label: 'Trauma e metas',
		description:
			'Trauma, estilo prático, foco em metas, homem, à noite.',
		answersByCode: {
			TOPICS: 'G',
			STYLE: 'A',
			PRIORITY: 'C',
			EXPERIENCE: 'B',
			GENDER_PREF: 'B',
			AUDIENCE: 'C',
			AVAILABILITY: 'C',
			AGE: 'C',
		},
	},
	{
		key: 'neutro',
		label: 'Tudo "tanto faz"',
		description:
			'Respostas neutras de propósito: deve cair no fallback (ordem do admin, sem percentual).',
		answersByCode: {
			TOPICS: 'M',
			STYLE: 'E',
			PRIORITY: 'F',
			EXPERIENCE: 'B',
			GENDER_PREF: 'D',
			AUDIENCE: 'C',
			AVAILABILITY: 'D',
			AGE: 'C',
		},
	},
];
